import React from 'react';
import { Button } from '../ui/Button';
import { Pill, ShieldCheck, Zap } from 'lucide-react';
export function Hero() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <header className="relative bg-brand-night text-brand-cream pt-20 pb-24 px-4 overflow-hidden" data-id="element-7">
      {/* Amber radial glow behind headline */}
      <div className="absolute inset-0 pointer-events-none" data-id="element-8">
        <div className="absolute top-1/3 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[400px] bg-brand-amber/10 rounded-full blur-[100px]" data-id="element-9"></div>
      </div>

      <div className="relative max-w-4xl mx-auto text-center z-10" data-id="element-10">
        {/* Eyebrow */}
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-brand-amber/10 text-brand-amber text-sm font-medium mb-8 border border-brand-amber/20" data-id="element-11">
          <span className="relative flex h-2 w-2" data-id="element-12">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-brand-amber opacity-75" data-id="element-13"></span>
            <span className="relative inline-flex rounded-full h-2 w-2 bg-brand-amber" data-id="element-14"></span>
          </span>
          New Research for High-Performance Professionals
        </div>

        <h1 className="text-4xl md:text-6xl font-serif font-bold leading-tight mb-6 text-balance text-brand-cream" data-id="element-15">
          Why Your Brain Turns{' '}
          <span className="text-brand-amber italic" data-id="element-16">"ON"</span> at 11:00 PM
        </h1>

        <p className="text-xl md:text-2xl text-brand-parchment mb-8 font-light max-w-2xl mx-auto leading-relaxed" data-id="element-17">
          (And the 3-Step "Thermal Sequence" to Force a Shut Down in Under 10
          Minutes)
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12" data-id="element-18">
          <Button onClick={scrollToPricing} withArrow className="w-full sm:w-auto" data-id="element-19">
            Get The Deep Sleep Protocol
          </Button>
          <p className="text-sm text-brand-muted mt-4 sm:mt-0 sm:ml-4 flex items-center gap-1" data-id="element-20">
            <ShieldCheck className="h-4 w-4 text-brand-amber" data-id="element-21" /> 100% Money-Back
            Guarantee
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-left max-w-3xl mx-auto mt-12 pt-12 border-t border-brand-border" data-id="element-22">
          <div className="flex items-start gap-3" data-id="element-23">
            <div className="bg-brand-amber/10 border border-brand-amber/20 p-2 rounded-lg" data-id="element-24">
              <Pill className="h-5 w-5 text-brand-amber" data-id="element-25" />
            </div>
            <div data-id="element-26">
              <h3 className="font-bold text-brand-cream text-sm" data-id="element-27">No Pills</h3>
              <p className="text-xs text-brand-muted" data-id="element-28">
                Biological reset, not chemical sedation.
              </p>
            </div>
          </div>
          <div className="flex items-start gap-3" data-id="element-29">
            <div className="bg-brand-amber/10 border border-brand-amber/20 p-2 rounded-lg" data-id="element-30">
              <Zap className="h-5 w-5 text-brand-amber" data-id="element-31" />
            </div>
            <div data-id="element-32">
              <h3 className="font-bold text-brand-cream text-sm" data-id="element-33">
                No "Sleep Hygiene"
              </h3>
              <p className="text-xs text-brand-muted" data-id="element-34">
                Forget blackout curtains and meditation apps.
              </p>
            </div>
          </div>
          <div className="flex items-start gap-3" data-id="element-35">
            <div className="bg-brand-amber/10 border border-brand-amber/20 p-2 rounded-lg" data-id="element-36">
              <ShieldCheck className="h-5 w-5 text-brand-amber" data-id="element-37" />
            </div>
            <div data-id="element-38">
              <h3 className="font-bold text-brand-cream text-sm" data-id="element-39">
                Works in 48 Hours
              </h3>
              <p className="text-xs text-brand-muted" data-id="element-40">
                Measurable deep sleep improvement.
              </p>
            </div>
          </div>
        </div>
      </div>
    </header>;
}